
<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     标签管理器
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="tag-manager-equip" :class="{ 'fold': fold, 'no-collapse': !collapse }">
    <el-scrollbar :native="false">
      <div class="manager-card" v-if="!fold" v-loading="loading" shadow="never" :body-style="{ 'padding': 0 }">
        <div class="flex column">
          <div class="left">
            <div class="manager-head flex align-items-center">
              <div class="bd font-md pl-lg">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                  <el-menu-item index="1" style="font-size: 16px;">标签</el-menu-item>
                  <el-menu-item index="2" style="font-size: 16px;">分组</el-menu-item>
                </el-menu>
              </div>
            </div>
            <div v-if="activeIndex === '1'" class="manager-body">
              <div v-if="!searchBox" class="tag-item flex" :class="{ 'text-success': !tagid }" role="button" @click="clickTag()">
                <span class="bd pl-lg">全部</span>
                <div class="ft">
                  <i class="el-icon-plus mr icon-button small" @click.stop="postTag()" />
                </div>
              </div>

              <draggable v-model="tags" @update="handleSortChange" handle=".mover">
                <transition-group type="transition">
                  <div v-for="tag in tags" :key="tag.tagid" class="tag-item flex"
                    :class="{ 'active': tag.tagid == tagid, 'active-drop': tag.tagid == active_tagid }"
                    @click.stop="clickTag(tag)">
                    <div class="hd mover">
                      <el-tooltip content="拖动调整顺序" placement="left" :open-delay="500">
                        <span class="iconfont2 iconfont icon-button icon-drag small"></span>
                      </el-tooltip>
                    </div>
                    <div class="bd flex ml-md" :class="{ 'text-success': tag.tagid == tagid }">
                      <span class="ellipsis" v-overflow-tooltip style="max-width: 120px;">{{ tag.title }}</span>
                      <span class="spot mr-sm ml-sm">.</span>
                      <span class="">{{ tag.count }}</span>
                    </div>
                    <div class="ft flex-center">
                      <div class="" @click.stop>
                        <el-dropdown trigger="click" placement="bottom-start" @visible-change="visibleChange">
                          <el-tooltip content="更多" placement="top" :open-delay="500">
                            <span class="iconfont2 iconfont icon-button icon-more small-sm more"
                              :class="{ 'active': tag.tagid == active_tagid }" @click="active_tagid = tag.tagid">
                            </span>
                          </el-tooltip>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="postTag(tag)"><i
                                class="el-icon-edit mr-sm icon-button small"></i>编辑</el-dropdown-item>
                            <el-dropdown-item @click.native="deleteTag(tag)"><i
                                class="el-icon-delete mr-sm icon-button small"></i>删除</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
          <div v-if="activeIndex === '2'" class="manager-body">
            <div v-if="!searchBox" class="tag-item flex align-items-center" :class="{ 'text-success': !active_groupid && active_groupid === '' }" role="button" @click="clickGroup()">
              <span class="bd pl-lg">全部</span>
              <div class="ft flex align-items-center">
                <el-tooltip v-if="!isExpand" content="全部展开" placement="top">
                  <i class="iconfont icon-arrow-up mr icon-button small" @click.stop="expandGroup" style="transform: rotate(180deg);margin-top: 2px;"/>
                </el-tooltip>
                <el-tooltip v-else content="全部收起" placement="top">
                  <i class="iconfont icon-arrow-up mr icon-button small" @click.stop="expandGroup"/>
                </el-tooltip>
                <i class="el-icon-plus mr icon-button small" @click.stop="postTag()" />
                <i class="el-icon-search icon-button mr text-muted" style="font-size: 16px;" @click.stop="showSearch()"></i>
              </div>
            </div>
            <div v-else style="margin: 0 8px;">
              <el-input
                ref="groupSearch"
                placeholder="搜索"
                clearable
                clear @blur="handleBlur" @clear="handleClear"
                v-model="searchContent">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            
            <div v-if="!searchBox" class="tag-item flex" :class="{ 'text-success': active_groupid === 0 }" role="button" @click="ungrouped()">
              <span class="" style="padding-left: 50px;">未分组</span>
            </div>
            <div v-loading="treeLoading">
              <el-tree
                v-if="group.length"
                :data="group"
                node-key="groupid"
                ref="treeGroup"
                @node-click="handleClick"
                @node-drop="handleDrop"
                @node-expand="handleExpand"
                @node-collapse="handleCollapse"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :default-expanded-keys="defaultExpandedKeys"
                highlight-current
                :draggable="!searchBox"
                :allow-drop="allowDrop">
                <span class="custom-tree-node" :class="[node.level == 3 && 'custom3',searchBox && 'search_status',active_groupid == data.groupid && 'text-success']" slot-scope="{ node, data }">
                  <span class="flex align-items-center">
                    <el-tooltip v-if="!searchBox" content="拖动调整顺序" placement="top" :open-delay="200">
                      <span class="iconfont icon-drag" style="font-size: 18px;color: #999;"></span>
                    </el-tooltip>
                    <span class="ellipsis" v-overflow-tooltip :class="[node.level == 1 && 'margin_left1',node.level == 2 && 'margin_left2',node.level == 3 && 'margin_left3']">{{ data.title }}</span>
                    <span class="spot mr-sm ml-sm">·</span>
                    <span class="">{{ data.count }}</span>
                  </span>
                  
                  <div class="ft flex-center" style="width: 24px">
                    <div class="" @click.stop>
                      <el-dropdown trigger="click" placement="bottom-start">
                        <el-tooltip content="更多" placement="top" :open-delay="500">
                          <span class="iconfont2 iconfont icon-button icon-more small-sm more" style="width: 24px;height: 24px">
                          </span>
                        </el-tooltip>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="node.level <= 2" @click.native="append(data)"><i
                              class="el-icon-plus mr-sm icon-button small"></i>新建子分组</el-dropdown-item>
                          <el-dropdown-item @click.native="appendBefore(data)"><i
                              class="iconfont2 iconfont icon-new-above mr-sm icon-button small"></i>上方新建分组</el-dropdown-item>
                          <el-dropdown-item @click.native="appendAfter(data)"><i
                              class="iconfont2 iconfont icon-new-below mr-sm icon-button small"></i>下方新建分组</el-dropdown-item>
                          <el-dropdown-item @click.native="editGroup(data)"><i
                              class="el-icon-edit mr-sm icon-button small"></i>编辑</el-dropdown-item>
                          <el-dropdown-item @click.native="remove(node, data)"><i
                              class="el-icon-delete mr-sm icon-button small"></i>删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="right" :class="[!collapse && 'active', isEnter && 'show']" @mouseenter="handleEnter"
            @mouseleave="handleLeave" @mousemove="handleMove">
            <el-tooltip content="关闭标签管理器" placement="top" :open-delay="500">
              <span class="iconfont2 iconfont icon-button icon-circle-left manager" @click="togglePanel(1)"></span>
            </el-tooltip>
          </div>
        </div>
      </div>

      <div v-else class="icon-button flex justify-content-center">
        <el-tooltip content="打开标签管理器" placement="top" :open-delay="500">
          <span class="iconfont2 iconfont icon-button icon-circle-right mt-sm" :class="{ 'active': tagid }" @click="togglePanel(0)"></span>
        </el-tooltip>
      </div>

    </el-scrollbar>

    <div v-if="foot" class="slot-foot flex-center"
      :class="[fold && 'foot-width', !collapse && 'active', foot && 'foot-color']">
      <slot name="recycle">
      </slot>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { getallApi, postApi, deleteApi, sortApi } from "@/api/fam/famTagApi";
import {
  listGroupTreeApi,
  groupAddApi,
  groupEditApi,
  groupMoveApi,
  groupDeleteApi
} from "@/api/rms/rmsEquipApi";
let id = 1000;
export default {
  name: "TagManager",

  components: {
    draggable
  },

  props: {
    value: {
      type: Number,
      default: undefined
    },

    type: {
      type: String,
      default: "equip"
    },

    foot: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      typeMap: {
        equip: "设备",
        dev: "模型",
        member: "用户"
      },
      fold: 0,

      loading: false,
      tags: [],

      inputPopShow: false,
      inputName: "",
      inputValid: true,
      active_tagid: null,
      isEnter: false,

      activeIndex: localStorage.getItem(`__TAG_GROUP_INDEX__`) || "1",

      groupData: [],
      treeLoading: false,
      active_groupid: "",

      searchContent: "",
      searchBox: false,
      isExpand: false,
      defaultExpandedKeys: [],
      parent_node: [],
    };
  },

  computed: {
    tagid: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
    defaultGroupID() {
      return this.$store.state.commonStore.defaultGroupId;
    },
    group() {
      this.groupData = this.addLevel(this.groupData);
      return JSON.parse(JSON.stringify(this.groupData));
    }
  },
  watch: {
    searchContent(val) {
      if (this.activeIndex == 2) {
        this.$refs.treeGroup.filter(val);
      }
    },

    defaultExpandedKeys(val) {
      if(val.length>0) {
        const temp1 = this.bubbleSort(val)
        const temp2 = this.bubbleSort(this.parent_node)
        if(JSON.stringify(temp1) == JSON.stringify(temp2)) {
          this.isExpand = true
        }else {
          this.isExpand = false
        }
      }
    },
    fold(val) {
      if(!val && this.activeIndex == "2" && this.active_groupid) {
        this.$nextTick(() => {
          this.$refs.treeGroup.setCurrentKey(this.active_groupid);
        });
      }
      
    }
  },

  created() {
    this.active_groupid = this.defaultGroupID;
    this.fold = Number(
      localStorage.getItem(`__TAG_MANAGER_FOLD_${this.type.toUpperCase()}__`)
    );
    this.fetchData(true);
    this.fetchGroups();
    this.$emit("change", 0);
  },

  methods: {
    handleEnter() {
      this.isEnter = true;
    },
    handleLeave() {
      this.isEnter = false;
    },
    handleMove() {
      this.isEnter = true;
    },
    visibleChange(e) {
      if (!e) this.active_tagid = null;
    },
    togglePanel(fold) {
      this.fold = fold;
      localStorage.setItem(
        `__TAG_MANAGER_FOLD_${this.type.toUpperCase()}__`,
        fold
      );
      this.$emit("toggle", this.fold);
      if (this.fold == 1) this.isEnter = false;
    },

    fetchData(loading = false) {
      if (loading) this.loading = true;
      getallApi({ type: this.type }).then(res => {
        this.loading = false;
        if (!res.errno) {
          this.tags = res.data.list;
        }
      });
    },

    fetchGroups() {
      this.treeLoading = true;
      const that = this
      listGroupTreeApi().then(res => {
        this.treeLoading = false;
        if (!res.errno) {
          this.groupData = res.data.list;
          this.parent_node = []

          this.group.forEach(item => {
            if(item.children && item.children.length > 0) {
              that.parent_node.push(item.groupid)
              item.children.forEach(child => {
                if(child.children && child.children.length > 0) {
                  that.parent_node.push(child.groupid)
                }
              })
            }
          })
          this.isExpand = false
          if (this.activeIndex == "2" && this.active_groupid && !this.fold) {
            this.$nextTick(() => {
              this.$refs.treeGroup.setCurrentKey(this.active_groupid);
            });
          }
        }
      });
    },

    clickTag(tag) {
      if (tag && tag.tagid) {
        this.tagid = tag.tagid;
      } else {
        this.tagid = 0;
      }
      this.$emit("change", this.tagid);
    },

    postTag(tag) {
      const _this = this;
      
      if (this.activeIndex == "1") {
        let isFirstValidate = true; // 标记是否为首次校验
        const inputValidator = (value) =>{
          // 首次校验（框架初始化触发）直接通过，后续执行真实校验
          if (isFirstValidate) {
            isFirstValidate = false;
            return true;
          }
          if (tag && tag.title == value) return "名称未修改";
          for (const v of _this.tags) {
            if (v.title == value) return "标签已存在，请勿重复";
          }
          return true;
        }
        this.$prompt("", `${tag ? "编辑" : "新建"}标签`, {
          inputValue: tag ? tag.title : "",
          inputValidator: inputValidator,
          closeOnClickModal: false
        })
          .then(({ value }) => {
            if (value.length != 0 && value.trim().length != 0) {
              postApi(
                Object.assign({}, tag, { type: this.type, title: value })
              ).then(res => {
                if (!res.errno) {
                  this.$message.success("操作成功！");
                  this.fetchData();
                  this.$emit("update");
                  if (!tag) {
                    this.$emit("create");
                  } else {
                    this.$emit("edit");
                  }
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              this.$message.error("名称不能为空");
            }
          })
          .catch(() => {
            // 取消
          });
      } else if (this.activeIndex == "2") {
        this.$prompt("", `新建分组`, {
          inputValue: "",
          closeOnClickModal: false
        })
          .then(({ value }) => {
            if (value.length != 0 && value.trim().length != 0) {
              groupAddApi({ title: value }).then(res => {
                if (!res.errno) {
                  this.$message.success("操作成功！");
                  this.fetchGroups();
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              this.$message.error("名称不能为空");
            }
          })
          .catch(() => {
            // 取消
          });
      }
    },

    handleSortChange() {
      const tagids = this.tags.map(v => v.tagid);
      sortApi({ type: this.type, tagids }).then(res => {
        if (res.errno === 0) {
          this.fetchData();
          this.$emit("sort");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    deleteTag(tag) {
      this.$confirm(`即将删除标签「${tag.title}」，是否继续？`, "操作确认", {
        type: "error"
      })
        .then(() => {
          deleteApi({ type: this.type, tagid: tag.tagid }).then(res => {
            if (res.errno === 0) {
              this.$message.success("操作成功！");
              this.fetchData();
              this.$emit("delete");
              if (this.tagid == tag.tagid) {
                this.clickTag();
              }
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消删除
        });
    },

    handleSelect(key, keyPath) {
      this.activeIndex = key;
      localStorage.setItem(`__TAG_GROUP_INDEX__`, key);
      this.searchBox = false;
      this.searchContent = "";
      if (key == 2) {
        this.clickTag();
      } else {
        this.active_groupid = "";
        this.$store.commit("SET_GROUPID", this.active_groupid);
        this.$emit("group", this.active_groupid);
      }
    },

    clickGroup() {
      if (this.active_groupid) {
        this.fetchGroups();
      }
      this.active_groupid = "";
      this.$store.commit("SET_GROUPID", this.active_groupid);
      this.$emit("group", this.active_groupid);
    },
    ungrouped() {
      if (this.active_groupid) {
        this.fetchGroups();
      }
      this.active_groupid = 0;
      this.$store.commit("SET_GROUPID", this.active_groupid);
      this.$emit("group", this.active_groupid);
    },

    handleClick(data) {
      this.active_groupid = data.groupid;
      this.$store.commit("SET_GROUPID", this.active_groupid);
      this.$emit("group", this.active_groupid);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const params = { groupid: draggingNode.data.groupid };
      if (dropType == "inner") {
        const index = dropNode.data.children.findIndex(
          item => item.groupid === draggingNode.data.groupid
        );
        if (index > 0) {
          params.after_groupid = dropNode.data.children[index - 1].groupid;
          params.pid = dropNode.data.children[index - 1].pid;
        } else {
          params.after_groupid = null;
          params.pid = dropNode.data.groupid;
        }
      } else {
        if (Array.isArray(dropNode.parent.data)) {
          const index = dropNode.parent.data.findIndex(
            item => item.groupid === draggingNode.data.groupid
          );
          if (index > 0) {
            params.after_groupid = dropNode.parent.data[index - 1].groupid;
            params.pid = dropNode.parent.data[index - 1].pid;
          } else {
            params.after_groupid = null;
            params.pid = dropNode.data.pid;
          }
        } else {
          const index = dropNode.parent.data.children.findIndex(
            item => item.groupid === draggingNode.data.groupid
          );
          if (index > 0) {
            params.after_groupid =
              dropNode.parent.data.children[index - 1].groupid;
            params.pid = dropNode.parent.data.children[index - 1].pid;
          } else {
            params.after_groupid = null;
            params.pid = dropNode.data.pid;
          }
        }
      }

      groupMoveApi(params).then(res => {
        if (!res.errno) {
          this.$message.success("操作成功！");
          this.fetchGroups();
          this.$emit("group", this.active_groupid);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    allowDrop(draggingNode, dropNode, type) {
      const deep = this.getTreeDepth(draggingNode.data) + dropNode.level;
      if (deep > 4) {
        return false;
      }
      if (this.getTreeDepth(draggingNode.data) == 3) return type !== "inner";

      if (
        dropNode.data.level == 2 &&
        this.getTreeDepth(draggingNode.data) == 1
      ) {
        return true;
      }

      if (dropNode.data.level !== 1) {
        return type !== "inner";
      } else {
        return true;
      }
    },

    handleExpand(data, node) {
      this.defaultExpandedKeys.push(data.groupid)
    },

    handleCollapse(data, node) {
      var temp = []
      if(node.data.level == 1) {
        temp = node.data.children.map(item => {return item.groupid});
      }
      this.defaultExpandedKeys = this.defaultExpandedKeys.filter(item => item !== data.groupid);
      if(temp.length) {
        this.defaultExpandedKeys = this.defaultExpandedKeys.filter(item => !temp.includes(item));
      }
    },

    append(data) {
      const temp = this.findChildrenByGroupId(this.group, data.groupid, true);
      this.$prompt("", `新建分组`, {
        inputValue: "",
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          if (value.length != 0 && value.trim().length != 0) {
            groupAddApi({
              title: value,
              pid: data.groupid,
              after_groupid: 0
            }).then(res => {
              if (!res.errno) {
                this.$message.success("操作成功！");
                this.fetchGroups();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            this.$message.error("名称不能为空");
          }
        })
        .catch(() => {
          // 取消
        });
    },

    appendBefore(data) {
      const temp = this.findChildrenByGroupId(this.group, data.groupid);
      const index = temp.findIndex(item => item.groupid === data.groupid);
      this.$prompt("", `上方新建分组`, {
        inputValue: "",
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          if (value.length != 0 && value.trim().length != 0) {
            groupAddApi({
              title: value,
              pid: data.pid,
              after_groupid:
                index != -1
                  ? index == 0
                    ? null
                    : temp[index - 1].groupid
                  : null
            }).then(res => {
              if (!res.errno) {
                this.$message.success("操作成功！");
                this.fetchGroups();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            this.$message.error("名称不能为空");
          }
        })
        .catch(() => {
          // 取消
        });
    },

    appendAfter(data) {
      const temp = this.findChildrenByGroupId(this.group, data.groupid);
      this.$prompt("", `下方新建分组`, {
        inputValue: "",
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          if (value.length != 0 && value.trim().length != 0) {
            groupAddApi({
              title: value,
              pid: data.pid,
              after_groupid: data.groupid
            }).then(res => {
              if (!res.errno) {
                this.$message.success("操作成功！");
                this.fetchGroups();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            this.$message.error("名称不能为空");
          }
        })
        .catch(() => {
          // 取消
        });
    },

    editGroup(data) {
      const that = this;
      const arr = that.findChildrenByGroupId(that.group, data.groupid);
      this.$prompt("", `编辑分组`, {
        inputValue: data.title,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          if (value.length != 0 && value.trim().length != 0) {
            groupEditApi({ title: value, groupid: data.groupid }).then(res => {
              if (!res.errno) {
                this.$message.success("操作成功！");
                this.fetchGroups();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            this.$message.error("名称不能为空");
          }
        })
        .catch(() => {
          // 取消
        });
    },

    remove(node, data) {
      this.$confirm(
        data.children && data.children.length
          ? `即将删除分组「${data.title}」及其子分组，是否继续？`
          : `即将删除分组「${data.title}」，是否继续？`,
        "操作确认",
        {
          type: "error"
        }
      )
        .then(() => {
          groupDeleteApi({ groupid: data.groupid }).then(res => {
            if (!res.errno) {
              this.$message.success("操作成功！");
              if (
                this.active_groupid == data.groupid &&
                !Array.isArray(node.parent.data)
              ) {
                this.active_groupid = node.parent.data.groupid;
                this.$store.commit("SET_GROUPID", this.active_groupid);
              } else {
                this.active_groupid = "";
                this.$store.commit("SET_GROUPID", this.active_groupid);
              }
              this.fetchGroups();
              this.$emit("group", this.active_groupid);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消删除
        });
    },

    addLevel(data, level = 1) {
      return data.map(item => {
        // 创建一个新对象，避免直接修改原始数据
        if (item.level) delete item.level;
        const newItem = {
          ...item,
          level: level
        };
        // 如果有子元素，则递归调用 addLevel 函数，传入子元素数组和当前层级加 1
        if (item.children && item.children.length > 0) {
          newItem.children = this.addLevel(item.children, level + 1);
        }
        return newItem;
      });
    },

    getArrayDepth(arr) {
      let maxDepth = 0;

      function findDepth(element, currentDepth) {
        if (Array.isArray(element.children)) {
          currentDepth += 1; // 嵌套更深了，深度加一
          element.children.forEach(child => {
            findDepth(child, currentDepth); // 递归查找深度
          });
        } else {
          maxDepth = Math.max(maxDepth, currentDepth); // 更新最大深度
        }
      }

      arr.forEach(element => findDepth(element, 0)); // 对数组的每个元素查找深度

      return maxDepth;
    },

    getTreeDepth(node) {
      if (!node.children || node.children.length === 0) {
        // 如果当前节点没有子节点，返回深度1
        return 1;
      } else {
        // 如果有子节点，计算所有子节点的深度，并找出最大的深度
        let maxChildDepth = 0;
        for (let child of node.children) {
          maxChildDepth = Math.max(maxChildDepth, this.getTreeDepth(child));
        }
        // 当前节点的深度是子节点的最大深度加1
        return maxChildDepth + 1;
      }
    },

    findChildrenByGroupId(data, groupId, findChildren = false) {
      let result = [];
      const that = this;
      data.forEach(item => {
        if (item.groupid == groupId) {
          result = !findChildren ? data || [] : item.children || [];
        }
        if (!result.length && item.children && item.children.length > 0) {
          result = that.findChildrenByGroupId(
            item.children,
            groupId,
            findChildren
          );
        }
      });
      return result;
    },

    showSearch() {
      this.searchBox = true;
      this.$nextTick(() => {
        this.$refs.groupSearch.focus();
      });
    },

    // async handleChange() {
    //   let res = await getallApi({ type: this.type });
    //   if (!res.errno) {
    //     this.tags = res.data.list;
    //   }
    //   if (!this.searchContent) {
    //     return;
    //   }
    //   this.tags = this.tags.filter(item => {
    //     return item.title
    //       .toLowerCase()
    //       .includes(this.searchContent.toLowerCase());
    //   });
    // },

    handleBlur() {
      if (this.searchContent === "") {
        this.searchBox = false;
      }
    },

    handleClear() {
      this.$nextTick(() => {
        this.$refs.groupSearch.focus();
      });
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },

    expandGroup() {
      this.isExpand = !this.isExpand
      let treeList = this.group;
      //关键代码

      const that = this
      treeList.forEach(item => {
        that.$refs.treeGroup.store.nodesMap[item.groupid].expanded = that.isExpand;
        if(item.children && item.children.length > 0) {
          item.children.forEach(child => {
            that.$refs.treeGroup.store.nodesMap[child.groupid].expanded = that.isExpand;
          })
        }
      })
      if(that.isExpand) {
        that.defaultExpandedKeys = []
        that.group.forEach(item => {
          if(item.children && item.children.length > 0) {
            that.defaultExpandedKeys.push(item.groupid)
            item.children.forEach(child => {
              if(child.children && child.children.length > 0) {
                that.defaultExpandedKeys.push(child.groupid)
              }
            })
          }
        })
      }else {
        that.defaultExpandedKeys = []
      }
      
    },

    bubbleSort(arr) {
      const n = arr.length;
      for (let i = 0; i < n - 1; i++) {
        for (let j = 0; j < n - i - 1; j++) {
          if (arr[j] > arr[j + 1]) {
            // 交换元素位置
            const temp = arr[j];
            arr[j] = arr[j + 1];
            arr[j + 1] = temp;
          }
        }
      }
      return arr;
    },


  }
};
</script>

<style lang="scss">
.tag-manager-equip {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  padding: 0 0px;
  border: none;
  border-right: 1px solid #eee;

  .el-scrollbar__bar.is-vertical > div {
    display: none;
  }

  &.fold {
    width: 60px;
  }

  &.no-collapse {
    border-bottom-left-radius: 20px;
  }

  .icon-button {
    line-height: 36px;
    font-size: 24px;
    color: #999;
    cursor: pointer;
    transition: color 0.2s;

    &.small {
      font-size: 18px;
    }

    &.small-sm {
      font-size: 15px;
    }

    &:hover {
      color: #333;
    }

    &.active {
      color: #07c160;
    }

    .iconfont2 {
      &:hover {
        color: #07c160;
      }
    }
  }

  .manager-card {
    height: 100%;
    border: none;

    .right {
      height: 100%;
      width: 16px;
      position: fixed;
      left: 290px;
      z-index: 2;

      &.active {
        left: 391px;
      }

      &.show {
        &::after {
          width: 3px;
          height: 100%;
          position: absolute;
          background-color: #07c160;
          right: 6px;
          top: 0;
          content: "";
        }
      }

      .manager {
        display: none;
        height: 24px;
        line-height: 24px;
        width: 24px;
        font-size: 24px;
        border-radius: 50%;
        position: absolute;
        left: -4px;
        top: 19px;
        z-index: 99;
        background-color: rgba(249, 249, 249, 1);

        &:hover {
          color: #07c160;
        }
      }

      &:hover {
        cursor: e-resize;
        .manager {
          display: block;
        }
      }
    }
  }

  .manager-head {
    height: 60px;
    .el-menu--horizontal > .el-menu-item {
      height: 30px;
      line-height: 30px;
    }
    .el-menu-item {
      padding: 0;
      margin-right: 25px;
      margin-left: 15px;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: none;
    }
  }

  .manager-body {
    margin: 0 0 15px 0;

    .tag-item {
      user-select: none;
      height: 36px;
      line-height: 36px;
      transition: background-color 0.2s, transform 0.5s;

      &.text-success {
        background-color: rgba(7, 193, 96, 0.05);
      }

      > .hd {
        width: 32px;
        padding: 0 7px;
      }

      .iconfont2 {
        display: none;
        transition: display 0.2s;
      }

      .more {
        border-radius: 4px;
        width: 24px;
        text-align: center;
        margin-right: 10px;

        &:hover,
        &.active,
        &:focus {
          display: block;
          height: 24px;
          line-height: 24px;
          background-color: #e3e8ec;
        }
      }

      &:hover {
        background-color: #f5f7fa;

        .iconfont2 {
          display: block;
        }

        > .hd span {
          cursor: move;
        }
      }

      &.active {
        background-color: rgba(7, 193, 96, 0.05);

        .more {
          display: block;
        }
      }

      &.active-drop {
        .more {
          display: block;
        }
      }
    }

    .el-submenu__title,
    .el-menu-item {
      height: 40px;
      line-height: 40px;
    }
    .el-menu-item-group__title {
      height: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
    }

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
      margin-left: -36px;
      &.custom3 {
        margin-left: -16px;
      }
      .icon-drag {
        visibility: hidden;
        position: absolute;
        left: 10px;
      }
      .margin_left1 {
        margin-left: 32px;
        max-width: 112px;
      }
      .margin_left2 {
        margin-left: 32px;
        max-width: 96px;
      }
      .margin_left3 {
        margin-left: 26px;
        max-width: 80px;
      }
      &.search_status {
        .margin_left1 {
          margin-left: 32px;
          max-width: 112px;
        }
        .margin_left2 {
          margin-left: 32px;
          max-width: 96px;
        }
        .margin_left3 {
          margin-left: 26px;
          max-width: 80px;
        }
      }

      .more {
        border-radius: 4px;
        width: 24px;
        text-align: center;

        &:hover,
        &:focus {
          display: block;
          height: 24px;
          line-height: 24px;
          background-color: #e3e8ec;
        }
      }
    }

    .el-tree-node__content {
      height: 36px;
      padding-left: 32px!important;
      position: realtive;
      &:hover {
        background-color: #f5f7fa;
        .icon-drag {
          visibility: visible;
          cursor: move;
        }
        .margin_left1 {
          margin-left: 32px;
          max-width: 112px;
        }
        .margin_left2 {
          margin-left: 32px;
          max-width: 96px;
        }
        .margin_left3 {
          margin-left: 26px;
          max-width: 80px;
        }
      }
    }
    .el-tree-node__children {
      .el-tree-node__content {
        padding-left: 48px!important;
      }
    } 
    

    .el-tree {
      color: #000000;
    }
  }

  > .el-scrollbar {
    height: calc(100% - 60px);

    > .el-scrollbar__wrap {
      overflow-x: hidden;

      > .el-scrollbar__view {
        padding: 0 0 10px 0;
      }
    }
  }
}

.spot {
  line-height: 30px;
  font-weight: 900;
}

.slot-foot {
  width: 240px;
  position: fixed;
  bottom: 0;
  left: 60px;
  height: 60px;
  background-color: rgba(255, 255, 255, 1);
  z-index: 3;

  // border-top: 3px solid rgba(255, 255, 255, 1);
  &.foot-color {
    height: 59px;
    background-color: rgba(249, 249, 249, 1);
    border-top: 1px solid rgba(249, 249, 249, 1);
  }

  &.active {
    left: 160px;
    border-bottom-left-radius: 20px;
  }

  &.foot-width {
    width: 60px;
  }
}

.el-tooltip__popper.is-dark.tagmanager {
  max-width: 200px;
}
</style>
